import { render, staticRenderFns } from "./DossierUsersAddModal.vue?vue&type=template&id=5795621d&scoped=true&"
import script from "./DossierUsersAddModal.vue?vue&type=script&lang=ts&"
export * from "./DossierUsersAddModal.vue?vue&type=script&lang=ts&"
import style0 from "./DossierUsersAddModal.vue?vue&type=style&index=0&id=5795621d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795621d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5795621d')) {
      api.createRecord('5795621d', component.options)
    } else {
      api.reload('5795621d', component.options)
    }
    module.hot.accept("./DossierUsersAddModal.vue?vue&type=template&id=5795621d&scoped=true&", function () {
      api.rerender('5795621d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierUsersAddModal.vue"
export default component.exports